import RulesScreen from '../../Shared/RulesScreen';
import React from 'react';

const NewLendingRules: React.FC = () => (
  <RulesScreen rulesTableName={'New Lending Rules'} variationOnly={false} />
);

export default NewLendingRules;
